class MobileStickyAtc {
  constructor() {
    this._selectors = {
      root: '[js-mobile-sticky-atc-root]',
      stickyAnchor: '[js-mobile-sticky-atc-anchor]',
      drawerOpen: '[js-mobile-sticky-atc-drawer-open]',
      drawer: '[js-mobile-sticky-atc-drawer]',
      drawerClose: '[js-mobile-sticky-atc-drawer-close]',
      drawerCloseLegacy: '.js-drawer-close-size-select',
      drawerInnerClose: '.mobile-sticky-atc__size-drawer-close',
      variantList: '[js-mobile-sticky-atc-variant-list]',
      variantButton: '.mobile-sticky-atc__variant-btn:not(:disabled)',
      productForm: '.product-form',
      mainAddToCart: '#add-to-cart-button',
      pageContainer: '#page-container',
      productInfo: '#product-info',
      sizeSwatchSection: '.swatch-selection.size-selection',
      giftCardInput: '.product-form .input-gift_card',
      giftCardChecked: '.product-form .input-gift_card:checked',
      sizeSelectionChecked: '.size-selection input:checked',
      qtyError: '.product-info__swatch-container .qty-error',
      productSection: '[data-section-type="product"]',
      swatchLabel: 'label[data-variant-id]',
      swatchInput: '[data-swatch-input]',
      variantSelect: 'select[name="id"]',
      sizeErrorHint: '.mobile-sticky-atc__size-error-hint',
      sizeSelection: '.size-selection',
      swatchSizeLabel: '.swatch-size-label',
      inputGiftCard: '.input-gift_card',
      swatchGiftCard: '.swatch-gift_card',
      swatch: '.product-form .swatch',
      bisTrigger: '#BIS_trigger',
      wrapAddToBagButton: '.wrap_add-to-bag_button',
      mainAtcText: '[data-add-to-cart-text]',
      seedSizeDropdown: '.seed-size-dropdown',
      seedDropdownSelectedText: '[js-seed-dropdown-selected-text]',
      seedDropdown: '.seed-custom-dropdown',
      seedDropdownItem: '[js-seed-dropdown-item]',
      swatchContainer: '.product-info__swatch-container',
      wrapSizeSwatchElems: '#wrap-size-swatch-elems',
      wrapSizeSwatchHeader: '#wrap-size-swatch-elems > div.size-header.header',
      sizeAlert: '.btn_size_alert',
      legacyWrapBagTrigger: '.wrap_add-to-bag-elements .wrap_add-to-bag_button',
      recipientErrorWrapper: '.product-form__recipient-error-message-wrapper',
      recipientFieldMessages: '.recipient-fields .form__message',
      headerContainer: '#header-container',
    };

    this._constants = {
      scrollRevealPx: 1200,
      legacyScrollThresholdWithAlert: 1350,
      stickyHandoffNavBufferPx: 2,
      stickyHandoffLeadPx: 8,
      giftFormSubmitDelayMs: 400,
      bisAfterPickDelayMs: 280,
      variantListNs: 'variantChange.product.mobileStickyAtc',
      mirrorJqNs: 'mobileStickyAtcMirror',
      mirrorDeferMs: [50, 200, 600],
      mirrorObserverDebounceMs: 40,
      giftScrollDelaysMs: [0, 120, 450],
      sizeHintTransitionMs: 400,
      variantScrollStaggerMs: 180,
      scrollSettleFallbackMs: 520,
      atbNoSizeTrackingCooldownMs: 250,
    };

    this._sizeHint = {
      shellClass: 'mobile-sticky-atc__size-error-hint',
      innerClass: 'mobile-sticky-atc__size-error-inner',
      innerSelector: '.mobile-sticky-atc__size-error-inner',
      messageClass: 'mobile-sticky-atc__size-error',
      visibleClass: 'mobile-sticky-atc__size-error-hint--visible',
      closingAttr: 'data-atc-hint-closing',
    };

    this._prefixes = {
      size: [
        'Size: ',
        'size: ',
        'SIZE: ',
        'Size:',
        'size:',
        'SIZE:',
        'Size ',
        'size ',
        'SIZE ',
      ],
      color: [
        'Color: ',
        'color: ',
        'COLOR: ',
        'Color:',
        'color:',
        'COLOR:',
        'Color ',
        'color ',
        'COLOR ',
      ],
    };

    this._hintClearSelectors = [
      this._selectors.sizeSelection,
      this._selectors.swatchSizeLabel,
      this._selectors.inputGiftCard,
      this._selectors.swatchGiftCard,
      this._selectors.seedSizeDropdown,
      this._selectors.seedDropdown,
      this._selectors.seedDropdownItem,
    ];

    this.root = document.querySelector(this._selectors.root);
    this._variationMode = 'classic';
    this._isSingleSkuProduct = false;
    this._isGiftCardProduct = false;
    this._boundScrollSync = null;
    this._variation1MirrorMode = 'normal';
    this._wrapBagObserver = null;
    this._mainAtcObserver = null;
    this._bisObserver = null;
    this._mainAtcSlotHoldPx = null;
    this._atbNoSizeTrackingBound = false;
    this._lastAtbNoSizeTrackedAt = 0;
  }

  /* Init */

  init() {
    if (!this.root) return;

    this._prepareStickyAtcButtons();
    this._variationMode = this._croMode();
    this._isSingleSkuProduct = this.root.getAttribute('data-single-variant') === 'true';
    this._isGiftCardProduct = this.root.getAttribute('data-gift-card') === 'true';
    const classic = this._isClassic();

    this._bindAtbNoSizeTrackingFallback();
    this._bindDualList();

    if (this._isSingleSkuProduct) {
      this._initSingle();
      if (this._isVariation1() || this._isVariation2()) this._initMirror();
      if (classic) this._bindLegacyScroll();
      else if (this._isVariation1() || this._isVariation2()) this._bindCroScroll();
      if (this._isVariation2()) this._initDrawer();
      if (this._isVariation1()) this._initAnchor();
      if (this._isVariation1() || this._isVariation2()) this._bindSizeHintLifecycle();
      return;
    }

    if (classic) this._bindLegacyScroll();
    else this._bindCroScroll();

    if (this._isVariation2()) this._initDrawer();
    if (this._isVariation1()) this._initAnchor();
    if (this._isVariation1() || this._isVariation2()) {
      this._initMirror();
      this._bindSizeHintLifecycle();
    }
  }

  /* CRO / variation mode */

  _isVariation1() {
    return this._variationMode === '1';
  }

  _isVariation2() {
    return this._variationMode === '2';
  }

  _hasCroClass(name) {
    if (document.body.classList.contains(name)) return true;
    const main = document.getElementById('MainContent');
    return !!(main && main.classList.contains(name));
  }

  _croMode() {
    if (this._hasCroClass('mobile-sticky-atc-variation--2')) return '2';
    if (this._hasCroClass('mobile-sticky-atc-variation--1')) return '1';
    return 'classic';
  }

  _isClassic() {
    return (
      !this._hasCroClass('mobile-sticky-atc-variation--1') &&
      !this._hasCroClass('mobile-sticky-atc-variation--2')
    );
  }

  /* Scroll — sticky visibility */

  _scrollY() {
    return window.pageYOffset ?? document.documentElement.scrollTop ?? document.body.scrollTop ?? 0;
  }

  _deferScrollSync(fn) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
  }

  _legacyScrollThreshold() {
    const hasAlert =
      (window.jQuery && window.jQuery(this._selectors.sizeAlert).length) ||
      !!document.querySelector(this._selectors.sizeAlert);
    return hasAlert
      ? this._constants.legacyScrollThresholdWithAlert
      : this._constants.scrollRevealPx;
  }

  _isMobileStickyViewport() {
    try {
      return window.matchMedia('(max-width: 767px)').matches;
    } catch {
      return window.innerWidth <= 767;
    }
  }

  _navBottomPx() {
    const el = document.querySelector(this._selectors.headerContainer);
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    if (r.height < 1) return 0;
    return Math.ceil(r.bottom);
  }

  _shouldShowStickyAtcForScroll() {
    if (!this._isMobileStickyViewport()) return false;

    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    const scrollY = this._scrollY();

    if (!mainBtn) return scrollY > this._legacyScrollThreshold();

    const slot = mainBtn.closest(this._selectors.wrapAddToBagButton);
    const geometryEl = mainBtn.classList.contains('atc-active') && slot ? slot : mainBtn;
    const rect = geometryEl.getBoundingClientRect();

    if (rect.height < 2) return scrollY > this._legacyScrollThreshold();

    const navBottom = this._navBottomPx();
    const buf = this._constants.stickyHandoffNavBufferPx;

    if (navBottom > 0) {
      return rect.top < navBottom + buf;
    }

    const lead = this._constants.stickyHandoffLeadPx;
    if (rect.top <= lead) return true;
    if (rect.bottom <= 0) return true;
    return scrollY > this._legacyScrollThreshold();
  }

  _holdMainAtcLayoutSlot(mainBtn) {
    const slot = mainBtn.closest(this._selectors.wrapAddToBagButton);
    if (!slot) return;
    const h = Math.ceil(mainBtn.getBoundingClientRect().height);
    if (h < 1) return;
    this._mainAtcSlotHoldPx = h;
    slot.style.minHeight = `${h}px`;
  }

  _releaseMainAtcLayoutSlot(mainBtn) {
    const slot = mainBtn?.closest(this._selectors.wrapAddToBagButton);
    if (slot) slot.style.minHeight = '';
    this._mainAtcSlotHoldPx = null;
  }

  _syncMainAtcSlotMinHeightWhileSticky(mainBtn) {
    if (!mainBtn?.classList.contains('atc-active') || this._mainAtcSlotHoldPx == null) return;
    const slot = mainBtn.closest(this._selectors.wrapAddToBagButton);
    if (slot) slot.style.minHeight = `${this._mainAtcSlotHoldPx}px`;
  }

  _bindLegacyScroll() {
    const onScroll = () => {
      const atcTop = document.getElementById('atc-top');
      const mainBtn = document.getElementById('add-to-cart-button');
      if (!atcTop || !mainBtn) return;

      const show = this._shouldShowStickyAtcForScroll();
      const wasActive = mainBtn.classList.contains('atc-active');

      if (show && !wasActive) this._holdMainAtcLayoutSlot(mainBtn);
      atcTop.classList.toggle('atc-active', show);
      mainBtn.classList.toggle('atc-active', show);
      if (!show && wasActive) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this._releaseMainAtcLayoutSlot(mainBtn));
        });
      }

      if (show) this._syncMainAtcSlotMinHeightWhileSticky(mainBtn);
    };

    const onResize = () => {
      const mainBtn = document.getElementById('add-to-cart-button');
      if (mainBtn?.classList.contains('atc-active')) {
        this._syncMainAtcSlotMinHeightWhileSticky(mainBtn);
      }
      onScroll();
    };

    this._deferScrollSync(() => {
      onScroll();
      window.onscroll = onScroll;
      window.addEventListener('resize', onResize);
    });
  }

  _bindCroScroll() {
    this._boundScrollSync = () => this._toggleSticky();
    this._boundResizeHandoffSync = () => {
      const mainBtn = document.querySelector(this._selectors.mainAddToCart);
      if (mainBtn?.classList.contains('atc-active')) {
        this._syncMainAtcSlotMinHeightWhileSticky(mainBtn);
      }
      this._toggleSticky();
    };
    window.addEventListener('scroll', this._boundScrollSync);
    window.addEventListener('resize', this._boundResizeHandoffSync);
    this._deferScrollSync(() => this._toggleSticky());
  }

  _scrolledPast() {
    return this._shouldShowStickyAtcForScroll();
  }

  _toggleSticky() {
    const show = this._scrolledPast();

    // Single-SKU markup only renders #atc-top (anchor), not the v2 drawer trigger.
    if (this._isVariation1() || (this._isVariation2() && this._isSingleSkuProduct)) {
      const stickyAnchor = this._stickyAnchorEl();
      const mainAddButton = document.querySelector(this._selectors.mainAddToCart);
      if (stickyAnchor && mainAddButton) {
        const wasActive = mainAddButton.classList.contains('atc-active');
        if (show && !wasActive) this._holdMainAtcLayoutSlot(mainAddButton);
        stickyAnchor.classList.toggle('atc-active', show);
        mainAddButton.classList.toggle('atc-active', show);
        if (!show && wasActive) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => this._releaseMainAtcLayoutSlot(mainAddButton));
          });
        }
        if (show) this._syncMainAtcSlotMinHeightWhileSticky(mainAddButton);
      }
    } else if (this._isVariation2()) {
      const drawerTrigger = this.root.querySelector(this._selectors.drawerOpen);
      if (drawerTrigger) drawerTrigger.classList.toggle('atc-active', show);
    }
  }

  /* Sticky target */

  _stickyAnchorEl() {
    return this.root
      ? this.root.querySelector(this._selectors.stickyAnchor)
      : document.querySelector(this._selectors.stickyAnchor);
  }

  _syncMirrorTarget() {
    if (this._isVariation1() || (this._isVariation2() && this._isSingleSkuProduct)) {
      return this._stickyAnchorEl();
    }
    if (this._isVariation2() && this.root) return this.root.querySelector(this._selectors.drawerOpen);
    return null;
  }

  _mirrorApplies() {
    return !!this._syncMirrorTarget();
  }

  _visible(el) {
    if (!el || el.classList.contains('d-none')) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  /* Mirror label / BIS */

  _mainAtcReady() {
    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    return !!(mainBtn && !mainBtn.disabled && this._visible(mainBtn));
  }

  _mainBtnText(mainBtn) {
    if (!mainBtn) return '';
    const span = mainBtn.querySelector(this._selectors.mainAtcText);
    if (span) return String(span.textContent || '').trim();
    return String(mainBtn.textContent || '').trim();
  }

  _bisLabel(bisBtn) {
    if (!bisBtn) return 'Email When Available';
    const inner = bisBtn.querySelector('.btn');
    const raw =
      String(bisBtn.textContent || '').trim() ||
      (inner ? String(inner.textContent || '').trim() : '');
    return raw || 'Email When Available';
  }

  _applyStickySoldOutState(sticky, soldOut) {
    const tag = sticky.tagName.toLowerCase();
    if (soldOut) {
      sticky.setAttribute('aria-disabled', 'true');
      if (tag === 'a') sticky.setAttribute('tabindex', '-1');
      if (tag === 'button') sticky.disabled = true;
    } else {
      sticky.removeAttribute('aria-disabled');
      if (tag === 'a') sticky.removeAttribute('tabindex');
      if (tag === 'button') sticky.disabled = false;
    }
  }

  _ensureStickyAtcIconMarkup(button) {
    if (!button) return;

    if (!button.style.display) {
      button.style.display = 'flex';
    }

    let labelEl = button.querySelector(this._selectors.mainAtcText);
    if (!labelEl) {
      const plainSpan = button.querySelector(
        'span:not(.add-to-cart-icon):not(.add-to-cart-icon--progress):not(.add-to-cart-icon--check)'
      );
      if (plainSpan) {
        plainSpan.setAttribute('data-add-to-cart-text', '');
        labelEl = plainSpan;
      }
    }

    if (button.querySelector('.add-to-cart-icon')) return;

    const insertBefore = labelEl || button.firstChild;
    const template = document.getElementById('add-to-cart-icons-template');
    if (template && template.content) {
      button.insertBefore(template.content.cloneNode(true), insertBefore);
      return;
    }

    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (!mainBtn) return;

    mainBtn.querySelectorAll('.add-to-cart-icon').forEach((icon) => {
      button.insertBefore(icon.cloneNode(true), insertBefore);
    });
  }

  _prepareStickyAtcButtons() {
    if (!this.root) return;

    this.root
      .querySelectorAll(
        '#atc-top[data-sticky-atc], .mobile-sticky-atc__v2-trigger, [js-mobile-sticky-atc-anchor], [js-mobile-sticky-atc-drawer-open]'
      )
      .forEach((button) => this._ensureStickyAtcIconMarkup(button));
  }

  _syncMirror() {
    if (!this._mirrorApplies()) return;

    const sticky = this._syncMirrorTarget();
    this._ensureStickyAtcIconMarkup(sticky);
    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (!mainBtn || !sticky) {
      if (
        (this._isVariation1() || this._isVariation2()) &&
        !this._isSingleSkuProduct &&
        mainBtn
      ) {
        this._applyCroMainAtcWhenNoSticky();
      }
      return;
    }

    const bisBtn = document.querySelector(this._selectors.bisTrigger);

    const mainHidden = mainBtn.classList.contains('d-none');
    const bisShown = !!(bisBtn && this._visible(bisBtn));
    const mainShown = this._visible(mainBtn);
    const mainDisabled = !!mainBtn.disabled;
    const mainLabel = this._mainBtnText(mainBtn);

    let mode = 'normal';
    let label = mainLabel || 'Add to Bag';

    if (bisShown || (mainHidden && bisBtn)) {
      mode = 'bis';
      label = this._bisLabel(bisBtn);
    } else if (mainShown && mainDisabled && !bisShown) {
      if (/sold\s*out|unavailable/i.test(mainLabel)) {
        mode = 'soldout';
      } else {
        mode = 'needsSelection';
      }
      label = mode === 'needsSelection' ? 'Add to Bag' : mainLabel || label;
    } else if (mainShown && !mainDisabled) {
      mode = 'normal';
      label = mainLabel || label;
    }

    const urlVariant = this._variantParamInUrl();
    const selectionComplete = this._selectionOk();
    const v2WaitlistNoSize = this._v2EmailWaitlistNoSizeYet();

    if (!urlVariant && !selectionComplete && !v2WaitlistNoSize) {
      mode = 'needsSelection';
      label = 'Add to Bag';
    } else if (!selectionComplete && (mode === 'bis' || mode === 'soldout') && !v2WaitlistNoSize) {
      mode = 'needsSelection';
      label = 'Add to Bag';
    }

    if (v2WaitlistNoSize) {
      mode = 'bis';
      label = this._bisLabel(bisBtn);
    }

    this._variation1MirrorMode = mode;

    let labelEl = sticky.querySelector(this._selectors.mainAtcText);
    if (!labelEl) {
      labelEl = document.createElement('span');
      labelEl.setAttribute('data-add-to-cart-text', '');
      sticky.appendChild(labelEl);
    }
    labelEl.textContent = label;

    sticky.classList.toggle('mobile-sticky-atc__anchor--bis', mode === 'bis');
    sticky.classList.toggle('mobile-sticky-atc__anchor--soldout', mode === 'soldout');

    this._applyStickySoldOutState(sticky, mode === 'soldout');
    sticky.classList.toggle('is-adding', mainBtn.classList.contains('is-adding'));
    sticky.classList.toggle('is-added', mainBtn.classList.contains('is-added'));
    this._ensureBisObserver();
    this._applyCroMainAtcEnabledState(mode);
  }

  _applyCroMainAtcEnabledState(mode) {
    if ((!this._isVariation1() && !this._isVariation2()) || this._isSingleSkuProduct) return;
    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (!mainBtn || !this._visible(mainBtn)) return;

    if (mode === 'soldout') return;

    mainBtn.disabled = false;
    mainBtn.removeAttribute('disabled');
  }

  _applyCroMainAtcWhenNoSticky() {
    if ((!this._isVariation1() && !this._isVariation2()) || this._isSingleSkuProduct) return;
    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (!mainBtn || !this._visible(mainBtn)) return;

    const mainLabel = this._mainBtnText(mainBtn);
    if (/sold\s*out|unavailable/i.test(mainLabel)) return;

    mainBtn.disabled = false;
    mainBtn.removeAttribute('disabled');
  }

  _syncMirrorOrMainAtcCleanup() {
    if (this._mirrorApplies()) {
      this._syncMirror();
      return;
    }
    if ((this._isVariation1() || this._isVariation2()) && !this._isSingleSkuProduct) {
      this._applyCroMainAtcWhenNoSticky();
    }
  }

  _deferMirror() {
    const run = () => this._syncMirrorOrMainAtcCleanup();
    run();
    this._constants.mirrorDeferMs.forEach((ms) => window.setTimeout(run, ms));
  }

  _debouncedMirrorObserver(target, options) {
    if (!target || typeof MutationObserver === 'undefined') return null;
    let t;
    const debounceMs = this._constants.mirrorObserverDebounceMs;
    const observer = new MutationObserver(() => {
      window.clearTimeout(t);
      t = window.setTimeout(() => this._syncMirrorOrMainAtcCleanup(), debounceMs);
    });
    observer.observe(target, options);
    return observer;
  }

  _ensureBisObserver() {
    if (!this._mirrorApplies() || this._bisObserver || typeof MutationObserver === 'undefined') return;
    const bisBtn = document.querySelector(this._selectors.bisTrigger);
    if (!bisBtn) return;

    this._bisObserver = this._debouncedMirrorObserver(bisBtn, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  _initMirror() {
    if (
      !this._mirrorApplies() &&
      !(this._isVariation1() && !this._isSingleSkuProduct) &&
      !(this._isVariation2() && !this._isSingleSkuProduct)
    )
      return;

    this._deferMirror();
    window.addEventListener('popstate', () => this._deferMirror());

    const jqNs = this._constants.mirrorJqNs;
    if (window.jQuery) {
      const $section = window.jQuery(this._selectors.productSection);
      if ($section.length) {
        $section.on(`variantChange.product.${jqNs}`, () => this._deferMirror());
        $section.on(`variantKitChange.product.${jqNs}`, () => this._deferMirror());
      }
      window.jQuery(document).on(
        `variantChange.${jqNs} variantKitChange.${jqNs}`,
        () => this._deferMirror()
      );
    }

    if (this._mirrorApplies()) {
      const bag = document.querySelector(this._selectors.wrapAddToBagButton);
      if (bag) {
        if (this._wrapBagObserver) this._wrapBagObserver.disconnect();
        this._wrapBagObserver = this._debouncedMirrorObserver(bag, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (mainBtn) {
      if (this._mainAtcObserver) this._mainAtcObserver.disconnect();
      this._mainAtcObserver = this._debouncedMirrorObserver(mainBtn, {
        attributes: true,
        attributeFilter: ['class', 'disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  _mirrorStickyInteraction(evt, { preventDefault = true } = {}) {
    if (!this._mirrorApplies()) return false;

    if (this._variation1MirrorMode === 'bis') {
      if (this._v2EmailWaitlistNoSizeYet()) return false;
      if (preventDefault) evt.preventDefault();
      const bisBtn = document.querySelector(this._selectors.bisTrigger);
      if (bisBtn) bisBtn.click();
      return true;
    }

    if (this._variation1MirrorMode === 'soldout') {
      if (preventDefault) evt.preventDefault();
      return true;
    }

    return false;
  }

  /* Selection / submit guards */

  _selectionOk() {
    const hasGiftAmountSwatches = !!document.querySelector(this._selectors.giftCardInput);
    if (this._isGiftCardProduct || hasGiftAmountSwatches) {
      return !!document.querySelector(this._selectors.giftCardChecked);
    }

    if (document.querySelector(this._selectors.seedDropdownSelectedText)) {
      for (const input of document.querySelectorAll(this._selectors.swatchInput)) {
        if (input.type !== 'radio' || !input.checked) continue;
        if (input.classList.contains('input-size') || input.classList.contains('input-gift_card')) {
          return true;
        }
      }
      return false;
    }

    const sizeSwatchSection = document.querySelector(this._selectors.sizeSwatchSection);
    return !sizeSwatchSection || !!document.querySelector(this._selectors.sizeSelectionChecked);
  }

  _variantParamInUrl() {
    try {
      const v = new URLSearchParams(window.location.search).get('variant');
      return !!(v && String(v).trim() !== '');
    } catch {
      return false;
    }
  }

  _domVariantResolved() {
    const mainBtn = document.querySelector(this._selectors.mainAddToCart);
    if (mainBtn) {
      const id = mainBtn.getAttribute('data-variant-id');
      if (id != null && String(id).trim() !== '') return true;
    }
    const form = document.querySelector(this._selectors.productForm);
    if (!form) return false;
    const idField = form.querySelector('input[name="id"], select[name="id"]');
    return !!(idField && idField.value != null && String(idField.value).trim() !== '');
  }

  _historyVariantUrlsEnabled() {
    const section = document.querySelector(this._selectors.productSection);
    return section?.getAttribute('data-enable-history-state') === 'true';
  }

  _canSubmitFromSticky() {
    if (!this._selectionOk() || !this._mainAtcReady()) return false;
    return (
      !this._historyVariantUrlsEnabled() ||
      this._variantParamInUrl() ||
      this._domVariantResolved()
    );
  }

  _trackAtbClickNoSizeMobile() {
    const now = Date.now();
    if (
      this._lastAtbNoSizeTrackedAt &&
      now - this._lastAtbNoSizeTrackedAt < this._constants.atbNoSizeTrackingCooldownMs
    )
      return;
    if (
      !this._isMobileStickyViewport() ||
      this._isSingleSkuProduct ||
      this._isGiftCardProduct ||
      this._selectionOk()
    )
      return;

    this._lastAtbNoSizeTrackedAt = now;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'pdp_atb_click_no_size_mobile' });

    if (window.DY && typeof window.DY.API === 'function') {
      try {
        window.DY.API('event', {
          name: 'pdp_atb_click_no_size_mobile',
        });
      } catch (err) {
        // Keep DY failures from blocking add-to-bag interactions.
      }
    }
  }

  _bindAtbNoSizeTrackingFallback() {
    if (this._atbNoSizeTrackingBound) return;
    this._atbNoSizeTrackingBound = true;

    const atbSelectors = [
      this._selectors.mainAddToCart,
      this._selectors.stickyAnchor,
      this._selectors.drawerOpen,
      this._selectors.legacyWrapBagTrigger,
    ].join(', ');

    document.addEventListener(
      'click',
      (evt) => {
        if (!this._isMobileStickyViewport()) return;
        const target = evt.target instanceof Element ? evt.target : null;
        if (!target) return;
        if (!target.closest(atbSelectors)) return;

        this._trackAtbClickNoSizeMobile();
      },
      true
    );
  }

  /* Size hint & scroll-to-size */

  _scrollMid(el) {
    if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  _scrollToVariantSelection() {
    const seedDrop = document.querySelector(this._selectors.seedSizeDropdown);
    const sizeSwatchSection = document.querySelector(this._selectors.sizeSwatchSection);
    const hasGiftAmountSwatches = !!document.querySelector(this._selectors.giftCardInput);
    let target = seedDrop || sizeSwatchSection;
    if (!target && hasGiftAmountSwatches) target = document.querySelector(this._selectors.swatch);
    if (!target) target = document.querySelector(this._selectors.productInfo);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  _whenScrollSettled(onDone) {
    if (typeof onDone !== 'function') return;
    const root = document.scrollingElement || document.documentElement;
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      root.removeEventListener('scrollend', onScrollEnd);
      window.clearTimeout(fallbackId);
      onDone();
    };
    const onScrollEnd = () => finish();
    if ('onscrollend' in window) {
      root.addEventListener('scrollend', onScrollEnd, { passive: true });
    }
    const fallbackId = window.setTimeout(finish, this._constants.scrollSettleFallbackMs);
  }

  _goToVariantSelection(onAfterScroll) {
    const productInfo = document.querySelector(this._selectors.productInfo);
    if (productInfo) productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => {
      this._scrollToVariantSelection();
      this._whenScrollSettled(onAfterScroll);
    }, this._constants.variantScrollStaggerMs);
  }

  _sizeHintAlreadyOpen() {
    const vis = this._sizeHint.visibleClass;
    return [...document.querySelectorAll(this._selectors.sizeErrorHint)].some(
      (node) => node.isConnected && node.classList.contains(vis)
    );
  }

  _animateSizeHintOut(node, onDone) {
    const { innerSelector, visibleClass, closingAttr } = this._sizeHint;

    if (!node?.isConnected) {
      onDone?.();
      return;
    }
    if (!node.classList.contains(visibleClass)) {
      if (node.getAttribute(closingAttr) === 'true') {
        onDone?.();
        return;
      }
      node.remove();
      onDone?.();
      return;
    }
    const inner = node.querySelector(innerSelector);
    if (!inner) {
      node.remove();
      onDone?.();
      return;
    }
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallbackId);
      inner.removeEventListener('transitionend', onTransitionEnd);
      node.remove();
      onDone?.();
    };
    const onTransitionEnd = (evt) => {
      if (evt.target !== inner) return;
      if (evt.propertyName !== 'max-height') return;
      done();
    };
    node.setAttribute(closingAttr, 'true');
    const dur = this._constants.sizeHintTransitionMs;
    inner.style.transition = `max-height ${dur}ms cubic-bezier(0.29, 0.63, 0.44, 1)`;
    const hRaw = inner.getBoundingClientRect().height;
    const h = Math.max(Math.ceil(hRaw), inner.scrollHeight, 1);
    node.classList.remove(visibleClass);
    inner.style.maxHeight = `${h}px`;
    void inner.offsetHeight;
    inner.addEventListener('transitionend', onTransitionEnd);
    const fallbackId = window.setTimeout(done, dur + 200);
    window.requestAnimationFrame(() => {
      inner.style.maxHeight = '0px';
    });
  }

  _buildSizeHintShell() {
    const h = this._sizeHint;
    const shell = document.createElement('div');
    shell.className = h.shellClass;
    const inner = document.createElement('div');
    inner.className = h.innerClass;
    const msg = document.createElement('div');
    msg.className = h.messageClass;
    msg.setAttribute('role', 'status');
    msg.textContent = this._isGiftCardProduct ? 'Please select an amount.' : 'Please select a size.';
    inner.appendChild(msg);
    shell.appendChild(inner);
    inner.style.maxHeight = '0px';
    return shell;
  }

  _insertSizeHintNode(hint) {
    const sizeHeader = document.querySelector(this._selectors.wrapSizeSwatchHeader);
    if (sizeHeader) {
      sizeHeader.insertAdjacentElement('afterend', hint);
      return;
    }

    const wrap = document.querySelector(this._selectors.wrapSizeSwatchElems);
    if (wrap) {
      wrap.appendChild(hint);
      return;
    }

    const seedDrop = document.querySelector(this._selectors.seedSizeDropdown);
    if (seedDrop) {
      seedDrop.insertAdjacentElement('afterbegin', hint);
      return;
    }

    const swatchBox = document.querySelector(this._selectors.swatchContainer);
    if (swatchBox) {
      const sizeSection = swatchBox.querySelector(this._selectors.sizeSwatchSection);
      if (sizeSection?.parentNode) {
        sizeSection.parentNode.insertBefore(hint, sizeSection);
        return;
      }
      swatchBox.insertAdjacentElement('afterbegin', hint);
      return;
    }

    const sizeSwatchSection = document.querySelector(this._selectors.sizeSwatchSection);
    if (sizeSwatchSection?.parentNode) {
      sizeSwatchSection.parentNode.insertBefore(hint, sizeSwatchSection);
      return;
    }

    const swatch = document.querySelector(this._selectors.swatch);
    if (swatch?.parentNode) {
      swatch.parentNode.insertBefore(hint, swatch);
      return;
    }

    const productInfo = document.querySelector(this._selectors.productInfo);
    if (productInfo) productInfo.insertAdjacentElement('afterbegin', hint);
  }

  _revealSizeHint(shell) {
    const inner = shell.querySelector(this._sizeHint.innerSelector);
    if (!inner) return;
    const dur = this._constants.sizeHintTransitionMs;
    inner.style.transition = `max-height ${dur}ms cubic-bezier(0.29, 0.63, 0.44, 1)`;
    inner.style.maxHeight = 'none';
    const h = inner.scrollHeight;
    inner.style.maxHeight = '0px';
    void inner.offsetHeight;
    shell.classList.add(this._sizeHint.visibleClass);
    window.requestAnimationFrame(() => {
      inner.style.maxHeight = `${Math.max(Math.ceil(h), 1)}px`;
    });
  }

  _placeSizeHint() {
    if (this._sizeHintAlreadyOpen()) return;

    const existing = [...document.querySelectorAll(this._selectors.sizeErrorHint)];
    const insert = () => {
      const shell = this._buildSizeHintShell();
      this._insertSizeHintNode(shell);
      this._revealSizeHint(shell);
    };

    if (!existing.length) {
      insert();
      return;
    }
    let pending = existing.length;
    const onOneOut = () => {
      if (--pending === 0) insert();
    };
    existing.forEach((node) => this._animateSizeHintOut(node, onOneOut));
  }

  /* Variation 1 — anchor */

  _v1Click(evt, legacy) {
    if (this._mirrorStickyInteraction(evt)) return;
    evt.preventDefault();
    if (this._canSubmitFromSticky()) {
      this._submitAtc();
      return;
    }
    this._trackAtbClickNoSizeMobile();
    this._goToVariantSelection(() => {
      if (legacy && window.jQuery) return;
      this._placeSizeHint();
    });
    if (legacy && window.jQuery) {
      window.jQuery(this._selectors.legacyWrapBagTrigger).first().trigger('click');
      return;
    }
  }

  _hintClearingInteractionTarget(target) {
    if (!(target instanceof Element)) return false;
    if (this._hintClearSelectors.some((sel) => target.closest(sel))) return true;
    return false;
  }

  _dismissesSizeHintOnInputChange(target) {
    if (!(target instanceof HTMLInputElement)) return false;
    if (!target.hasAttribute('data-swatch-input')) return false;
    if (target.classList.contains('input-color')) return false;
    return (
      target.classList.contains('input-size') ||
      target.classList.contains('input-gift_card') ||
      target.classList.contains('other-variant')
    );
  }

  _dismissAllSizeHints() {
    document.querySelectorAll(this._selectors.sizeErrorHint).forEach((node) => {
      this._animateSizeHintOut(node);
    });
  }

  _bindSizeHintLifecycle() {
    document.addEventListener(
      'click',
      (evt) => {
        if (!this._hintClearingInteractionTarget(evt.target)) return;
        this._dismissAllSizeHints();
      },
      true
    );

    document.addEventListener('change', (evt) => {
      if (!this._dismissesSizeHintOnInputChange(evt.target)) return;
      this._dismissAllSizeHints();
    });
  }

  _bindVariation1MainAddToCart() {
    const btn = document.querySelector(this._selectors.mainAddToCart);
    if (!btn) return;

    btn.addEventListener(
      'click',
      (evt) => {
        if (this._mirrorStickyInteraction(evt)) return;
        if (this._canSubmitFromSticky()) return;

        this._trackAtbClickNoSizeMobile();
        evt.preventDefault();
        evt.stopImmediatePropagation();

        this._goToVariantSelection(() => this._placeSizeHint());
      },
      true
    );
  }

  _initAnchor() {
    const stickyAnchor = this._stickyAnchorEl();

    if (stickyAnchor) {
      stickyAnchor.addEventListener('click', (evt) => this._v1Click(evt, this._isClassic()));
    }

    this._bindVariation1MainAddToCart();
  }

  /* Variation 2 — drawer */

  _drawerEl() {
    return document.querySelector(this._selectors.drawer);
  }

  _dualColorDrawer() {
    const drawer = this._drawerEl();
    return drawer?.getAttribute('data-drawer-dual-color-size') === 'true';
  }

  _endDrawerBusy(drawerElement) {
    drawerElement.classList.remove('is-adding');
    drawerElement.setAttribute('aria-busy', 'false');
  }

  _bindVariation2MainAddToCart(onVariation2NeedSizeInteraction) {
    const btn = document.querySelector(this._selectors.mainAddToCart);
    if (!btn) return;

    btn.addEventListener(
      'click',
      (evt) => {
        if (this._mirrorStickyInteraction(evt)) return;
        if (this._canSubmitFromSticky()) return;

        onVariation2NeedSizeInteraction(evt, { stopForMain: true });
      },
      true
    );
  }

  _initDrawer() {
    const drawer = this._drawerEl();
    const openDrawerButton = this.root.querySelector(this._selectors.drawerOpen);
    const pageContainer = document.querySelector(this._selectors.pageContainer);

    const openDrawer = () => {
      document.body.classList.add('js-drawer-open', 'js-drawer-open-size-select');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
    };

    const closeDrawer = () => {
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-size-select');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    };

    const onVariation2NeedSizeInteraction = (evt, { stopForMain } = {}) => {
      this._trackAtbClickNoSizeMobile();

      // Desktop: size drawer is hidden — reuse the Variation 1 size-hint path instead.
      const useDesktopSizeHint = !this._isMobileStickyViewport();

      if (this._v2EmailWaitlistNoSizeYet()) {
        evt.preventDefault();
        if (stopForMain) evt.stopImmediatePropagation();
        // All sizes OOS for color: keep waitlist/BIS flow. On desktop, don't fall back to the hidden drawer.
        const waitlistFallback = useDesktopSizeHint
          ? () => this._goToVariantSelection(() => this._placeSizeHint())
          : openDrawer;
        if (this._v2SelectFirstSizeForActiveColorAndOpenBis(waitlistFallback)) return;
        waitlistFallback();
        return;
      }
      if (stopForMain) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
      if (useDesktopSizeHint) {
        this._goToVariantSelection(() => this._placeSizeHint());
        return;
      }
      openDrawer();
    };

    if (openDrawerButton) {
      openDrawerButton.addEventListener('click', (evt) => {
        if (this._mirrorStickyInteraction(evt, { preventDefault: false })) return;

        if (this._canSubmitFromSticky()) {
          this._submitAtc();
          return;
        }

        onVariation2NeedSizeInteraction(evt, { stopForMain: false });
      });
    }

    this._bindVariation2MainAddToCart(onVariation2NeedSizeInteraction);

    const drawerCloseControl =
      document.querySelector(this._selectors.drawerClose) ||
      document.querySelector(this._selectors.drawerCloseLegacy);
    if (drawerCloseControl) drawerCloseControl.addEventListener('click', closeDrawer);

    const mainAtc = document.querySelector(this._selectors.mainAddToCart);

    if (pageContainer) {
      pageContainer.addEventListener('click', (evt) => {
        if (
          document.body.classList.contains('js-drawer-open-size-select') &&
          drawer &&
          !drawer.contains(evt.target) &&
          openDrawerButton &&
          !openDrawerButton.contains(evt.target) &&
          !(mainAtc && mainAtc.contains(evt.target))
        ) {
          closeDrawer();
        }
      });
    }

    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape' && document.body.classList.contains('js-drawer-open-size-select')) {
        closeDrawer();
      }
    });

    if (!drawer) return;

    drawer.addEventListener('click', (evt) => {
      const choiceButton = evt.target.closest(this._selectors.variantButton);
      if (!choiceButton || drawer.classList.contains('is-adding')) return;

      const selectedVariantId = choiceButton.getAttribute('data-variant-id');
      if (!selectedVariantId) return;

      const endBusy = () => this._endDrawerBusy(drawer);

      if (this._isGiftCardProduct) {
        this._giftAfterDrawer(drawer, closeDrawer, selectedVariantId);
        return;
      }

      if (typeof addProductToCartViaAjaxAndUpdateCartDrawer !== 'function') return;

      drawer.classList.add('is-adding');
      drawer.setAttribute('aria-busy', 'true');

      addProductToCartViaAjaxAndUpdateCartDrawer(parseInt(selectedVariantId, 10), 1, {
        onError: () => {
          endBusy();
        },
        onAfterCartLoad: () => {
          endBusy();
          const closeControl = drawer.querySelector(this._selectors.drawerInnerClose);
          if (closeControl) closeControl.click();
        },
      });
    });
  }

  /* Single SKU */

  _initSingle() {
    const singleSkuButton = this._stickyAnchorEl();
    if (!singleSkuButton) return;

    singleSkuButton.addEventListener('click', (evt) => {
      if (this._mirrorStickyInteraction(evt)) return;
      evt.preventDefault();
      this._submitAtc();
    });
  }

  /* V2 — email waitlist / color */

  _optVal(variant, optionIndex) {
    if (!variant) return '';
    if (optionIndex === 0) return variant.option1;
    if (optionIndex === 1) return variant.option2;
    return variant.option3;
  }

  _colorOptionIndex() {
    if (typeof productJSON === 'undefined' || !productJSON.options) return 0;
    const idx = productJSON.options.findIndex((name) => /color|colour/i.test(String(name)));
    return idx >= 0 ? idx : 0;
  }

  _v2ActiveColorValue() {
    const form = document.querySelector(this._selectors.productForm);
    const colorIdx = this._colorOptionIndex();

    const checked = form?.querySelector('.input-color[data-swatch-input]:checked');
    if (checked && checked.value != null && String(checked.value).trim() !== '') {
      return checked.value;
    }

    const pos = colorIdx + 1;
    const optSelect = form?.querySelector(`[data-single-option-selector][data-index="option${pos}"]`);
    if (optSelect && optSelect.value != null && String(optSelect.value).trim() !== '') {
      return optSelect.value;
    }

    const v = this._pageVariant();
    return v ? this._optVal(v, colorIdx) : null;
  }

  _v2VariantsForActiveColor() {
    if (typeof productJSON === 'undefined' || !productJSON.variants) return [];
    const color = this._v2ActiveColorValue();
    if (color == null || String(color).trim() === '') return [];
    const colorIdx = this._colorOptionIndex();
    return productJSON.variants.filter((row) => String(this._optVal(row, colorIdx)) === String(color));
  }

  _v2AllSizesOosForActiveColor() {
    const rows = this._v2VariantsForActiveColor();
    if (!rows.length) return false;
    return rows.every((v) => !v.available);
  }

  _v2EmailWaitlistNoSizeYet() {
    return (
      this._isVariation2() &&
      !this._isGiftCardProduct &&
      !this._isSingleSkuProduct &&
      !this._selectionOk() &&
      this._v2AllSizesOosForActiveColor()
    );
  }

  _v2SelectFirstSizeForActiveColorAndOpenBis(fallbackOpenDrawer) {
    const rows = this._v2VariantsForActiveColor();
    if (!rows.length) return false;
    const first = rows[0];
    if (!this._pickVariant(first.id)) return false;

    this._deferMirror();

    const delay = this._constants.bisAfterPickDelayMs;
    window.setTimeout(() => {
      if (typeof window.seedDropDownUpdate === 'function') {
        window.seedDropDownUpdate();
      }
      this._deferMirror();
      const bisBtn = document.querySelector(this._selectors.bisTrigger);
      if (bisBtn) {
        bisBtn.click();
      } else if (typeof fallbackOpenDrawer === 'function') {
        fallbackOpenDrawer();
      }
    }, delay);

    return true;
  }

  /* Dual-color drawer list */

  _stripPrefix(value, prefixes) {
    let out = value;
    for (const prefix of prefixes) {
      if (out.indexOf(prefix) === 0) out = out.substring(prefix.length).trim();
    }
    return out;
  }

  _cleanOpt(label) {
    let value = String(label == null ? '' : label).trim();
    value = this._stripPrefix(value, this._prefixes.size);
    value = value.split(' Size').join('').split(' SIZE').join('').split(' size').join('');
    value = this._stripPrefix(value, this._prefixes.color);
    value = value.split(' Color').join('').split(' COLOR').join('').split(' color').join('');
    return value.trim();
  }

  _escape(text) {
    const node = document.createElement('div');
    node.textContent = text;
    return node.innerHTML;
  }

  _fillDualList(variant) {
    const drawer = this._drawerEl();
    if (
      !this._dualColorDrawer() ||
      typeof productJSON === 'undefined' ||
      !productJSON.variants ||
      !variant
    ) {
      return;
    }

    const colorOptionIndex = parseInt(drawer.getAttribute('data-color-option-index'), 10);
    const sizeOptionIndex = parseInt(drawer.getAttribute('data-size-option-index'), 10);
    if (Number.isNaN(colorOptionIndex) || Number.isNaN(sizeOptionIndex)) return;

    const activeColor = this._optVal(variant, colorOptionIndex);
    const list = drawer.querySelector(this._selectors.variantList);
    if (!list) return;

    const variantsForActiveColor = productJSON.variants.filter(
      (row) => String(this._optVal(row, colorOptionIndex)) === String(activeColor)
    );

    const uniqueSizeValues = [
      ...new Set(variantsForActiveColor.map((row) => String(this._optVal(row, sizeOptionIndex)))),
    ];

    let listHtml = '';
    for (const sizeValue of uniqueSizeValues) {
      const sizeMatches = variantsForActiveColor.filter(
        (row) => String(this._optVal(row, sizeOptionIndex)) === sizeValue
      );
      let chosenVariant = sizeMatches[0];
      for (const row of sizeMatches) {
        if (row.available) {
          chosenVariant = row;
          break;
        }
      }
      const isSoldOut = !chosenVariant.available;
      const buttonClass =
        'mobile-sticky-atc__variant-btn' + (isSoldOut ? ' mobile-sticky-atc__variant-btn--oos' : '');
      const disabledAttr = isSoldOut ? ' disabled' : '';
      listHtml +=
        '<li class="mobile-sticky-atc__variant-item"><button type="button" class="' +
        buttonClass +
        '" data-variant-id="' +
        chosenVariant.id +
        '"' +
        disabledAttr +
        '><span class="mobile-sticky-atc__variant-title">' +
        this._escape(this._cleanOpt(sizeValue)) +
        '</span></button></li>';
    }
    list.innerHTML = listHtml;
  }

  _pageVariant() {
    if (typeof getActiveVariant === 'function') {
      try {
        const fromHelper = getActiveVariant();
        if (fromHelper) return fromHelper;
      } catch {}
    }
    if (typeof productJSON !== 'undefined' && productJSON.variants) {
      try {
        const variantIdFromUrl = new URLSearchParams(window.location.search).get('variant');
        if (variantIdFromUrl) {
          const fromUrl = productJSON.variants.find((v) => String(v.id) === String(variantIdFromUrl));
          if (fromUrl) return fromUrl;
        }
      } catch {}
      const addToBagButton = document.querySelector(this._selectors.mainAddToCart);
      const variantIdFromButton = addToBagButton && addToBagButton.getAttribute('data-variant-id');
      if (variantIdFromButton) {
        return productJSON.variants.find((v) => String(v.id) === String(variantIdFromButton)) || null;
      }
    }
    return null;
  }

  _bindDualList() {
    if (!this._dualColorDrawer() || !window.jQuery) return;

    const onVariantChange = (event) => {
      if (event.variant) this._fillDualList(event.variant);
    };

    const $productSection = window.jQuery(this._selectors.productSection);
    if ($productSection.length) {
      $productSection.on(this._constants.variantListNs, onVariantChange);
    } else {
      window.jQuery(document).on(this._constants.variantListNs, onVariantChange);
    }

    const initialVariant = this._pageVariant();
    if (initialVariant) this._fillDualList(initialVariant);
  }

  _pickVariant(variantId) {
    const form = document.querySelector(this._selectors.productForm);
    if (!form) return false;

    for (const label of form.querySelectorAll(this._selectors.swatchLabel)) {
      if (String(label.getAttribute('data-variant-id')) !== String(variantId)) continue;
      const inputId = label.getAttribute('for');
      if (!inputId) continue;
      const input = document.getElementById(inputId);
      if (input && (input.type === 'radio' || input.type === 'checkbox')) {
        input.checked = true;
        if (window.jQuery) window.jQuery(input).trigger('change');
        return true;
      }
    }

    if (typeof productJSON !== 'undefined' && productJSON.variants) {
      const targetVariant = productJSON.variants.find((v) => String(v.id) === String(variantId));
      if (targetVariant) {
        const optionValues = [targetVariant.option1, targetVariant.option2, targetVariant.option3].filter(
          Boolean
        );
        for (const swatchInput of form.querySelectorAll(this._selectors.swatchInput)) {
          for (const opt of optionValues) {
            if (String(swatchInput.value) === String(opt)) {
              swatchInput.checked = true;
              if (window.jQuery) window.jQuery(swatchInput).trigger('change');
              return true;
            }
          }
        }
      }
    }

    const variantSelect = form.querySelector(this._selectors.variantSelect);
    if (variantSelect) {
      variantSelect.value = String(variantId);
      if (window.jQuery) window.jQuery(variantSelect).trigger('change');
      return true;
    }
    return false;
  }

  /* Gift card / recipient / submit */

  _scrollRecipientErr(form) {
    if (!form) return;
    const wrapper = form.querySelector(this._selectors.recipientErrorWrapper);
    if (wrapper && !wrapper.hidden) {
      const heading = wrapper.querySelector('.form__message');
      this._scrollMid(heading || wrapper);
      return;
    }
    for (const node of form.querySelectorAll(this._selectors.recipientFieldMessages)) {
      if (node.classList.contains('hidden')) continue;
      const err = node.querySelector('.error-message');
      if (err && String(err.textContent || '').trim()) {
        this._scrollMid(node);
        return;
      }
    }
    const firstInvalid = form.querySelector(':invalid');
    if (firstInvalid) {
      try {
        firstInvalid.focus({ preventScroll: true });
      } catch {}
      this._scrollMid(firstInvalid);
    }
  }

  _scrollAddErr(form) {
    const quantityError = document.querySelector(this._selectors.qtyError);
    if (quantityError) this._scrollMid(quantityError);
    else this._scrollRecipientErr(form);
  }

  _onAddErrScroll(form, syncFirst) {
    if (!window.jQuery) return;
    window.jQuery(document.body).one('errorAddItem.ajaxCart', () => {
      if (syncFirst) syncFirst();
      window.setTimeout(() => this._scrollAddErr(form), 100);
    });
  }

  _giftFormOk(form) {
    if (typeof form.checkValidity !== 'function') return true;
    if (form.checkValidity()) return true;
    if (typeof form.reportValidity === 'function') form.reportValidity();
    this._scrollRecipientErr(form);
    return false;
  }

  _deferGiftScroll(form) {
    this._constants.giftScrollDelaysMs.forEach((ms) => {
      window.setTimeout(() => this._scrollRecipientErr(form), ms);
    });
  }

  _submitAtc() {
    const mainButton = document.querySelector(this._selectors.mainAddToCart);
    if (!mainButton) return;

    if (
      mainButton.disabled &&
      (this._isVariation1() || this._isVariation2()) &&
      !this._isSingleSkuProduct &&
      !/sold\s*out|unavailable/i.test(this._mainBtnText(mainButton))
    ) {
      mainButton.disabled = false;
      mainButton.removeAttribute('disabled');
    }

    if (mainButton.disabled) return;

    const form = document.querySelector(this._selectors.productForm);
    if (this._isGiftCardProduct && form && typeof form.requestSubmit === 'function') {
      if (!this._giftFormOk(form)) return;
      this._onAddErrScroll(form, null);
      form.requestSubmit(mainButton);
      this._deferGiftScroll(form);
      return;
    }
    mainButton.click();
  }

  _giftAfterDrawer(drawerElement, closeDrawer, variantId) {
    const form = document.querySelector(this._selectors.productForm);
    const mainButton = document.querySelector(this._selectors.mainAddToCart);
    if (!form || !mainButton) return;

    const endBusy = () => this._endDrawerBusy(drawerElement);

    this._pickVariant(variantId);
    closeDrawer();

    window.setTimeout(() => {
      if (!this._giftFormOk(form)) return;

      drawerElement.classList.add('is-adding');
      drawerElement.setAttribute('aria-busy', 'true');

      if (window.CartUtils && window.PUB_SUB_EVENTS) {
        var endAfterAdd = CartUtils.subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(event) {
          if (event.source !== 'cart-add' && event.source !== 'product-form') return;
          endAfterAdd();
          endBusy();
          const closeControl = drawerElement.querySelector(this._selectors.drawerInnerClose);
          if (closeControl) closeControl.click();
        }.bind(this));
        this._onAddErrScroll(form, endBusy);
      } else if (window.jQuery) {
        window.jQuery(document.body).one('afterAddItem.ajaxCart', function() {
          endBusy();
          const closeControl = drawerElement.querySelector(this._selectors.drawerInnerClose);
          if (closeControl) closeControl.click();
        }.bind(this));
        this._onAddErrScroll(form, endBusy);
      }

      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
      else mainButton.click();
      this._deferGiftScroll(form);
    }, this._constants.giftFormSubmitDelayMs);
  }
}

(function bindMsatcVisualViewportInset() {
  const isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

  if (isAndroid) {
    document.documentElement.style.setProperty('--msatc-vv-bottom-gap', '0px');
    return;
  }

  if (typeof window.visualViewport === 'undefined') return;

  let lastGapPx = -1;
  let vvRaf = 0;

  const commitGap = () => {
    const vv = window.visualViewport;
    const ih = window.innerHeight;
    const offsetTop = typeof vv.offsetTop === 'number' ? vv.offsetTop : 0;
    const gap = Math.max(0, ih - vv.height - offsetTop);
    const rounded = Math.round(gap);
    if (rounded === lastGapPx) return;
    lastGapPx = rounded;
    document.documentElement.style.setProperty('--msatc-vv-bottom-gap', `${rounded}px`);
  };

  const schedule = () => {
    if (vvRaf) return;
    vvRaf = window.requestAnimationFrame(() => {
      vvRaf = 0;
      commitGap();
    });
  };

  commitGap();
  window.visualViewport.addEventListener('resize', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
})();

window.addEventListener('load', () => {
  new MobileStickyAtc().init();
});
